import { Tracker } from '../types';

/**
 * Context for tracker to pass to listener for the listener to have a stable reference to the active tracker
 * If a child tracker is created (eg on a model change), the reference is passed down to the child, which in turn registers itself as the active tracker
 */
export type ListenerTrackerContext = {
  tracker: Tracker; // eslint-disable-line @typescript-eslint/no-explicit-any
  lastPageEventTimeStamp?: number;
};

export const navigationEvents = ['referrer', 'exitLinkClicked', 'fileDownloaded'] as const;

export type NavigationEvent = typeof navigationEvents extends ReadonlyArray<infer T> ? T : never;

export type ListenerOptions = {
  /**
   * If provided listener is attached to node with the given id, else the listener is attached to the root
   */
  elementId?: string;
  /**
   * By default the listener automatically tracks referrer, external link and file download data on anchor elements.
   * If set to `true`, link data is only tracked if the required data attributes are provided
   * alternatively you can disable the automatic tracking of a subset of these events.
   */
  autoLinkTrackingDisabled?: boolean | Record<NavigationEvent, boolean>;
  /**
   * Specifies how to determine a link is internal
   * If type is string or RegExp, the link will be considered internal if host is same as current and value matches the pathname. In case of string that is true if pathname starts with the given value.
   */
  isInternalLink?: string | RegExp | ((url: URL) => boolean);

  /**
   * Specifies how to determine a link is of type download
   * The link will be considered as a download when the file extension is one of 'pdf','xlsx','docx', 'pptx','ppt','odt','zip','rar','rtf','txt','odp','mp4','jpg'.
   */
  isDownloadLink?: (url: URL) => boolean;
};
